import appStrings from '@/app/utility/string.utility.js';
import commonHelper from '@/app/utility/common.helper.utility';
import DatePicker from 'vue2-datepicker';
import { required } from 'vuelidate/lib/validators';
import RunRequest from '../../../request/submittedRequest/runRequest';
export default {
  name: 'ReceiptUpload',
  components: {
    DatePicker,
    RunRequest
  },
  watch: {
    currentPage: function() {
      this.getBillUploadData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getBillUploadData();
    },
    selectAllCheckBox: function() {
      this.checkUncheckAll();
    }
  },
  data() {
    return {
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      currentPage: 1,
      loader: false,
      fileName: null,
      fmsPrj: {
        text: null,
        value: null
      },
      status: {
        value: null,
        text: null
      },
      billCat: { value: null, text: null },
      billPeriodFrom: null,
      billPeriodTo: null,
      showValueSetModal: false,
      unsubscribe: null,
      billUploadData: [],
      billUploadFields: [
        {
          key: 'select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'status_flag',
          label: 'Status'
        },
        {
          key: 'status_msg',
          label: 'Status Message'
        },
        {
          key: 'doc_num',
          label: 'Document No.'
        },
        {
          key: 'customer_name'
        },
        {
          key: 'customer_site'
        },
        {
          key: 'billing_period_from'
        },
        {
          key: 'billing_period_to'
        },
        {
          key: 'gl_date',
          label: 'GL Date'
        },
        {
          key: 'billing_date'
        },
        {
          key: 'fp_gstn',
          label: 'FP GSTN'
        },
        {
          key: 'tp_gstn',
          label: 'TP GSTN'
        },
        {
          key: 'sac_code',
          label: 'SAC Code'
        },
        {
          key: 'hsn_code',
          label: 'HSN Code'
        },
        {
          key: 'bill_category'
        },
        {
          key: 'comp_group',
          label: 'Component Group'
        },
        {
          key: 'comp_name',
          label: 'Component Name'
        },
        {
          key: 'qty',
          label: 'Quantity'
        },
        {
          key: 'rate'
        },
        {
          key: 'revenue_ccid',
          label: 'Revenue CCID'
        },
        {
          key: 'revenue_account'
        },
        {
          key: 'tax_category'
        },
        {
          key: 'hdr_id'
        },
        {
          key: 'project'
        },
        {
          key: 'file_name'
        },
        {
          key: 'module'
        },
        {
          key: 'source'
        },
        {
          key: 'unit'
        },
        {
          key: 'subunit'
        },
        {
          key: 'complete_address'
        },
        {
          key: 'currency'
        },
        {
          key: 'payment_term'
        },
        {
          key: 'uom',
          label: 'UOM'
        },
        {
          key: 'meter_no'
        },
        {
          key: 'reference'
        },
        {
          key: 'particulars'
        },
        {
          key: 'details'
        }
      ],
      showExcelUploadModal: false,
      requestId: null,
      templateId: null,
      requestNumId: null,
      requestStatus: null,
      selectAllCheckBox: false,
      payload: {},
      showRunRequestModal: false,
      reqBillUpload: {
        fmsPrj: {
          text: null,
          value: null
        }
      },
      reqstNumId: null
    };
  },
  created() {
    this.eventBus.$on('resdata', data => {
      this.requestStatus = data.status;
      this.reqstNumId = data.requestNumberId;
    });
    
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'upload') {
          this.showExcelUploadModal = true;
        }
        if (actionName === 'delete') {
          this.deleteBillUpload();
        }
        if (actionName === 'download') {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'fmsTransaction/getBillUploadData',
            'fms-bill-upload',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  validations: {
    fmsPrj: {
      text: {
        required
      }
    }
  },
  methods: {
    checkUncheckAll() {
      this.billUploadData = this.billUploadData.map(data => {
        data.select =
          data.status_flag !== 'PROCESSED' && this.selectAllCheckBox;
        return data;
      });
    },
    deleteBillUpload() {
      const promt = confirm(
        'Are you sure, you want to delete this Bill Upload?'
      );
      if (promt) {
        const filterData = this.billUploadData.filter(data => data.select);
        const recieptUpload = filterData.map(elem => {
          return {
            id: elem.hdr_id
          };
        });
        const payload = { hdr_id: recieptUpload ? recieptUpload : null };
        this.loader = true;
        this.$store
          .dispatch('fmsTransaction/deleteBillUpload', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.editMode = false;
              this.showAlert = true;
              this.isSuccess = true;
              alert('Record Deleted Successfully');
            } else {
              this.showAlert = true;
              this.isSuccess = false;
              alert(response.response.data.message);
            }
          });
      }
    },
    getBillUploadData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.payload = {
          _page: this.currentPage - 1,
          _limit: this.perPage,
          fms_prj: this.fmsPrj.value,
          status_flag: this.status.value,
          file_name: this.fileName,
          bill_cat: this.billCat.value,
          billing_period_from: this.billPeriodFrom,
          billing_period_to: this.billPeriodTo
        };
        this.loader = true;
        this.$store
          .dispatch('fmsTransaction/getBillUploadData', this.payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.billUploadData = response.data.data.page;
              this.totalRows = response.data.data.total_elements;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    getSubmitRequest() {
      this.loader = true;
      this.$store
        .dispatch('template/getSubmitRequest', this.reqstNumId)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.requestStatus = resp.data.data[0].status;
            this.reqId = resp.data.data[0].id;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_FLAG) {
        this.status.text = item.value_meaning;
        this.status.value = item.value_code;
      } else if (this.vsetCode === appStrings.VALUESETTYPE.FMS_PROJECT) {
        this.fmsPrj = {
          value: item.value_code,
          text: item.value_code
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.BILL_CAT_VSET) {
        this.billCat.text = item.value_meaning;
        this.billCat.value = item.value_code;
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === appStrings.VALUESETTYPE.STATUS_FLAG) {
        this.status.text = null;
        this.status.value = null;
      } else if (vsetCode === this.fmsPrj.value) {
        this.fmsPrj.text = null;
        this.fmsPrj.value = null;
      } else if (vsetCode === this.billCat.value) {
        this.billCat.text = null;
        this.billCat.value = null;
      }
    },
    clearFilters() {
      this.fileName = null;
      this.billPeriodFrom = null;
      this.billPeriodTo = null;
      this.status = { value: null, text: null };
      this.fmsPrj = { value: null, text: null };
      this.billCat = { value: null, text: null };
      this.billUploadData = [];
      this.totalRows = null;
      this.currentPage = 1;
      this.requestStatus = null;
    },
    runRequest() {
      this.showRunRequestModal = true;
    },
    resetModal() {
      this.showRunRequestModal = false;

      this.eventBus.$on('resdata', data => {
        this.requestStatus = data.status;
        this.reqstNumId = data.requestNumberId;
      });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
    this.eventBus.$off('resdata');
  }
};
